/**
 * Genera un objeto data a partir de los controles de una plantilla
 * Recorre todas las secciones y items para extraer los valores por defecto
 * @param {Object} template - La plantilla con su estructura de controls
 * @returns {Object} - Objeto con todas las propiedades y sus valores por defecto
 */
export function generateDataFromTemplate(template) {
  const data = {};
  
  if (!template || !template.controls || !template.controls.sections) {
    console.warn('Template sin controls válidos');
    return data;
  }
  
  // Iterar sobre todas las secciones
  template.controls.sections.forEach(section => {
    if (section.items && Array.isArray(section.items)) {
      // Iterar sobre todos los items de la sección
      section.items.forEach(item => {
        if (item.id && item.default !== undefined) {
          // Agregar el id como key y el default como value
          data[item.id] = item.default;
        }
      });
    }
  });
  
  return data;
}

/**
 * Genera un GUID aleatorio
 * @returns {string} - GUID en formato xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 */
export function generateGuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0,
      v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * Obtiene el valor de autohide de una plantilla
 * Lee el valor desde controls.config.autohide
 * @param {Object} template - La plantilla con su estructura de controls
 * @returns {number} - Segundos de autohide (0 si no está configurado o es inválido)
 */
export function getTemplateAutohide(template) {
  // Retrocompatibilidad: Si no existe config o autohide, retorna 0
  if (!template || !template.controls || !template.controls.config) {
    return 0;
  }
  
  const autohide = template.controls.config.autohide;
  
  // Validar que sea un número válido y no negativo
  if (typeof autohide === 'number' && autohide >= 0) {
    return autohide;
  }
  
  return 0;
}
